// extracted by mini-css-extract-plugin
export var sliderRange = "_ei-2";
export var sliderRoot = "_ei-0";
export var sliderThumb = "_ei-3";
export var sliderTrack = "_ei-1";